import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/app/layouts/Default.vue").then(m => m.default || m)),
  fullscreen: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/app/layouts/Fullscreen.vue").then(m => m.default || m))
}